import React, { Component, Fragment } from 'react';
import _ from 'lodash'
import moment from "moment/moment";
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from "react-redux";
import { ReactComponent as DownloadIconLight } from '../../../../assets/icons/new/DownloadIcon.svg'
import { ReactComponent as DownloadIconDark } from '../../../../assets/icons/new/DownloadIcon_Dark.svg'
import config from '../../../../combineConfig';
import { DatePicker } from "../../../../components/Input";
import RetryableContent from "../../../../components/RetryableContent";
import TextToolTip from "../../../../components/TextToolTip";
import { fdsInquiryService, inquiryService } from "../../../../services";
import * as actions from '../../../../store/actions'
import { CommonUtils, execTypes, KeyCodeUtils, LoadStatus, mDate, OUTPUT_REPORT, Random, reportParams, reportTypes, Role, RPT_ID, SELECTOR_ACCOUNT_SCREEN, ToastUtil } from "../../../../utils";
import Util from 'modules/util';
import TableExtremeCustom2 from 'components/Table/TableExtreme/TableExtremeCustom2';

import './ConsolidatedProfitLossReport.scss';
import RenderGridCell from 'components/Table/TableExtreme/RenderGridCell';
import SelectorAccountCustomer from 'components/SelectorAccount/SelectorAccountCustomer';
import { ReactComponent as IconInfoActive } from '../../../../assets/icons_new/icon_info_active.svg';

const rowPerPage = 200;
let CM_RECORDS = []

let columnsDefault =
    [
        /* Tiểu khoản */
        {
            dataField: "producttypename",
            dataType: "string",
            allowReordering: true,  // không cho di chuyển
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "center",
            visibleIndex: 0,
        },
        /* Ngày */
        {
            dataField: "txdate",
            dataType: "string",
            allowReordering: true,
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "center",
            visibleIndex: 1,
        },
        /* Mã CK */
        {
            dataField: "symbol",
            dataType: "string",
            allowReordering: true,
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "center",
            visibleIndex: 2,
        },
        /* Khối lượng */
        {
            dataField: "netqtty",
            dataType: "string",
            allowReordering: true,
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "right",
            visibleIndex: 3,
        },
        /* Giá vốn */
        {
            dataField: "costprice_i",
            dataType: "string",
            allowReordering: true,
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "right",
            visibleIndex: 4,
        },
        /* Giá trị vốn */
        {
            dataField: "netvalue",
            dataType: "string",
            allowReordering: true,
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "right",
            visibleIndex: 5,
        },
        /* Giá thực hiện */
        {
            dataField: "costprice_o",
            dataType: "string",
            allowReordering: true, // không cho di chuyển
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "right",
            visibleIndex: 6,
        },
        /* Giá trị thực hiện */
        {
            dataField: "sellvalue",
            dataType: "string",
            allowReordering: true,
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "right",
            visibleIndex: 7,
        },
        /* Lãi/Lỗ */
        {
            dataField: "pnl",
            dataType: "string",
            allowReordering: true,
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "right",
            visibleIndex: 8,
        },
        /* % Lãi/Lỗ */
        {
            dataField: "pnlrate",
            dataType: "string",
            allowReordering: true,
            minWidth: "150",
            width: '180',
            visible: true,
            alignment: "right",
            visibleIndex: 9,
        },
    ]


const totalDefault =
    [
        {
            column: "netqtty",
            summaryType: "sum",
            displayFormat: "{0}",
            valueFormat: ",##0",
        },
        {
            column: "netvalue",
            summaryType: "sum",
            displayFormat: "{0}",
            valueFormat: ",##0",
        },
        {
            column: "sellvalue",
            summaryType: "sum",
            displayFormat: "{0}",
            valueFormat: ",##0",
        },
        {
            column: "pnl",
            summaryType: "sum",
            displayFormat: "{0}",
            valueFormat: ",##0",
        },
        {
            column: "sumPnlrate",
            summaryType: "custom",
            showInColumn: "pnlrate",
            displayFormat: "{0} %",
            valueFormat: ",##0.##",
            isSumCustom: true,
            // priceColor: true,
        },
    ]
class ConsolidatedProfitLossReport extends Component {
    keyIdRequest = Random.randomOrderRequestId(this.props.userInfo && this.props.userInfo.username && this.props.userInfo.username);
    state = {
        fromDate: null,
        toDate: null,
        symbol: null,
        execType: execTypes[0],
        orderStatus: 'ALL',
        records: [],
        loadStatus: LoadStatus.NONE,
        orderHistoryStatus: [],
        page: 1,
        listAccounts: [],
        onReloadData: true,
    };

    ORDER_ID_LENGTH = 6;

    orderHistoryAllCode = {
        cdtype: "FE",
        cdname: "ORSTATUS"
    };

    orderHistoryDisPlayAllCode = {  // Trạng thái dùng để map lên cột trạng thái trong bảng
        cdtype: "OD",
        cdname: "ORSTATUS"
    };


    isBroker = () => {
        const { role } = this.props;
        return role === Role.BROKER;
    };

    minDate = null;

    constructor(props) {
        super(props);
        // Trunc current date
        const currentDate = new Date(this.props.currentDate * 1000);
        currentDate.setHours(0, 0, 0, 0);

        this.state.fromDate = currentDate;
        this.state.toDate = currentDate;

        this.minDate = moment(currentDate).subtract(mDate, 'days').toDate();
        this.searchBtnRef = React.createRef();
        //this.searchBtnRef = React.createRef();
        this.selectAccountCustomerRef = React.createRef();
        this.iconInfoRef = React.createRef();
        this.iconInfoSellValueRef = React.createRef();
        this.iconInfoProfitRef = React.createRef();
    }

    _setState = (obj, callback) => {
        if (this.mounted) {
			this.setState(obj, callback);
		}
    }
		
	componentWillUnmount() {
        this.mounted = false
    }
	

    checkDate = () => {
        const { fromDate, toDate } = this.state;
        let arrayDate = moment(fromDate).format('YYYY-MM-DD').split("-");
        arrayDate[1] -= 1; // thang trong array = thang hien tai - 1
        let rangeDate = moment(arrayDate).add(6, 'M');
        return moment(toDate).isBefore(moment(rangeDate));
    }

    renderCustomCosPriceHeader = () => {
        return (
            <Fragment>
                <FormattedMessage id='open-position.cost-price' />&nbsp;
                <IconInfoActive ref={this.iconInfoRef} id='cost-price-icon-tt' />
                <TextToolTip
                    tooltipText={<FormattedMessage id="consolidated-report.costprice-tooltip" />}
                    targetID={this.iconInfoRef}
                    placement='bottom'
                ></TextToolTip>
            </Fragment>
        )
    }

    renderCustomSellValueHeader = () => {
        return (
            <Fragment>
                <FormattedMessage id='consolidated-report.table.price' />&nbsp;
                <IconInfoActive ref={this.iconInfoSellValueRef} id='cost-price-icon-tt1' />
                <TextToolTip
                    tooltipText={<FormattedMessage id="consolidated-report.sell-value-tooltip" />}
                    targetID={this.iconInfoSellValueRef}
                    placement='bottom'
                ></TextToolTip>
            </Fragment>
        )
    }

    renderCustomProfitHeader = () => {
        return (
            <Fragment>
                <FormattedMessage id='consolidated-report.table.profit-and-loss' />&nbsp;
                <IconInfoActive ref={this.iconInfoProfitRef} id='cost-price-icon-tt2' />
                <TextToolTip
                    tooltipText={<FormattedMessage id="consolidated-report.profit-tooltip" />}
                    targetID={this.iconInfoProfitRef}
                    placement='bottom'
                ></TextToolTip>
            </Fragment>
        )
    }

    returnCaption = (dataField) => {
        switch (dataField) {
            case 'producttypename':
                return "consolidated-report.table.sub-account";
            case 'txdate':
                return "consolidated-report.table.day";
            case 'symbol':
                return "consolidated-report.table.symbol-code";
            case 'netqtty':
                return "consolidated-report.table.sales";
            case 'costprice_i':
                // return "consolidated-report.table.cost-of-capital";
                return this.renderCustomCosPriceHeader;
            case 'netvalue':
                return "consolidated-report.table.value-of-capital";
            case 'costprice_o':
                // return "consolidated-report.table.price";
                return this.renderCustomSellValueHeader;
            case 'sellvalue':
                return "consolidated-report.table.selling-value";
            case 'pnlrate':
                return "consolidated-report.table.per-profit-and-loss";
            case 'pnl':
                // return "consolidated-report.table.profit-and-loss";
                return this.renderCustomProfitHeader;
            default:
                return null;
        }
    }

    renderSwitch = (dataField) => {
        const { currentAccount } = this.state;
        const isFDS = currentAccount && currentAccount.accounttype === "FDS" ? true : false
        if (!isFDS) {
            switch (dataField) {
                case 'producttypename':
                    return (e) => RenderGridCell.renderGridCellCommon(e.row.data.producttypename);
                case 'txdate':
                    return (e) => RenderGridCell.renderGridCellCommon(e.row.data.txdate);
                case 'symbol':
                    return (e) => RenderGridCell.renderGridCellSymbol(e.row.data.symbol);
                case 'netqtty':
                    return (e) => RenderGridCell.renderGridCellQuantity(e.row.data.netqtty);
                case 'costprice_i':
                    return (e) => RenderGridCell.renderGridCellPrice(e.row.data.costprice_i, 'PRICE');
                case 'netvalue':
                    return (e) => RenderGridCell.renderGridCellPrice(e.row.data.netvalue, 'PRICE');
                case 'costprice_o':
                    return (e) => RenderGridCell.renderGridCellPrice(e.row.data.costprice_o, 'PRICE');
                case 'sellvalue':
                    return (e) => RenderGridCell.renderGridCellPrice(e.row.data.sellvalue, 'PRICE');
                case 'pnlrate':
                    return (e) => RenderGridCell.renderGridCellPercentageRate(e.row.data.pnlrate, 2);
                case 'pnl':
                    return (e) => RenderGridCell.renderGridCellvalue(e.row.data.pnl, 'PRICE', true);
                default:
                    return null;
            }
        } else {
            switch (dataField) {
                case 'producttypename':
                    return (e) => RenderGridCell.renderGridCellCommon(e.row.data.producttypename);
                case 'txdate':
                    return (e) => RenderGridCell.renderGridCellCommon(e.row.data.txdate);
                case 'symbol':
                    return (e) => RenderGridCell.renderGridCellSymbol(e.row.data.symbol);
                case 'netqtty':
                    return (e) => RenderGridCell.renderGridCellQuantity(e.row.data.closedqtty);
                case 'costprice_i':
                    return (e) => RenderGridCell.renderGridCellPriceDecimal(e.row.data.costprice);
                case 'netvalue':
                    return (e) => RenderGridCell.renderGridCellPrice(e.row.data.vwapamt, 'PRICE');
                case 'costprice_o':
                    return (e) => RenderGridCell.renderGridCellPriceDecimal(e.row.data.sellingprice);
                case 'sellvalue':
                    return (e) => RenderGridCell.renderGridCellPrice(e.row.data.matchamt, 'PRICE');
                case 'pnlrate':
                    return (e) => RenderGridCell.renderGridCellPercentageRate(e.row.data.relipnl);
                case 'pnl':
                    return (e) => RenderGridCell.renderGridCellvalue(e.row.data.vrplamt, 'PRICE', true);
                default:
                    return null;
            }
        }
    }

    search = () => {
        this.setReloadData();
    }

    apiPaging = async (obj) => {
        const { fromDate, toDate, currentAccount } = this.state;

        let checkDateResult = CommonUtils.checkDate(fromDate, toDate)

        if (!checkDateResult) {
            return [];
        }
        // const momentFromDate = moment(fromDate);
        // const momentToDate = moment(toDate);
        // if (!momentFromDate.isValid() || !momentToDate.isValid()) {
        //     ToastUtil.error('common.fail-to-load-data', 'common.date-range-invalid');
        //     return [];
        // }

        // if (momentToDate.isBefore(momentFromDate)) {
        //     ToastUtil.error('common.fail-to-load-data', 'common.date-range-invalid-1');
        //     return [];
        // }

        // if (!this.checkDate()) {
        //     ToastUtil.error('common.fail-to-load-data', 'common.date-range-invalid-2');
        //     return [];
        // }

        try {
            let self = this
            let _obj = {
                custid: currentAccount.id,
                fromDate: fromDate,
                page: obj.page,
                limitRow: obj.limitRow,
                toDate: toDate,
            }
            if (currentAccount && currentAccount.accounttype === "SEC") {
                return inquiryService.getPnlExecuted(_obj.custid, _obj.fromDate, _obj.toDate, _obj.page, _obj.limitRow).then((data) => {
                    // if (data && data.d) {
                    //     data = data.d
                    // }
                    data = this.processOrderData(data);
                    return data
                })
                    .catch((error) => {
                        ToastUtil.errorApi(error, 'CONSOLIDATED_PROFIT_LOSS_REPORT');
                        return []
                    });
            }
            if (currentAccount && currentAccount.accounttype === "FDS") {
                return fdsInquiryService.getPnlExecuted(_obj.custid, _obj.fromDate, _obj.toDate, _obj.page, _obj.limitRow).then((data) => {
                    if (data && data.d) {
                        data = data.d
                    }
                    return data
                })
                    .catch((error) => {
                        ToastUtil.errorApi(error, 'CONSOLIDATED_PROFIT_LOSS_REPORT');
                        return []
                    });
            }

            if (currentAccount && currentAccount.accounttype === "ALL") {
                let custid = this.isBroker() ? this.props.curCustomer.custid : this.props.userInfo.custid
                if (custid) {
                    return inquiryService.getPnlExecutedAllBase(custid, _obj.fromDate, _obj.toDate, _obj.page, _obj.limitRow).then((data) => {

                        // if (data && data.d) {
                        //     data = data.d
                        // }
                        data = this.processOrderData(data);
                        return data
                    })
                        .catch((error) => {
                            ToastUtil.errorApi(error, 'CONSOLIDATED_PROFIT_LOSS_REPORT');
                            return []
                        });
                }
                return []
            }

        } catch (e) {
            //console.log('apiPaging().:Err.:', e)
            return []
        }
    }



    genReport = (exptype) => {
        let { currentAccount, fromDate, toDate, symbol, execType, orderStatus } = this.state;
        fromDate = moment(fromDate).format(config.app.SERVER_DATE_FORMAT);
        toDate = moment(toDate).format(config.app.SERVER_DATE_FORMAT);
        symbol = symbol ? symbol : reportParams.ALL;
        execType = execType ? execType : reportParams.ALL;
        orderStatus = orderStatus ? orderStatus : reportParams.ALL;

        let custid = this.isBroker() ? this.props.curCustomer.custid : this.props.userInfo.custid
        if (currentAccount) {
            let rptId = '';
            let inpArr = [];
            let accountId = currentAccount.id
            if (currentAccount.accounttype === "ALL") {
                accountId = "ALL"
            }
            rptId = RPT_ID.GET_PNL_EXECUTED;
            inpArr = [custid, accountId, symbol, fromDate, toDate, OUTPUT_REPORT.OFFSET, OUTPUT_REPORT.LIMIT];

            for (let i = 0; i < inpArr.length; i++) {
                let str = CommonUtils.stringifyInputExcel(inpArr[i]);
                inpArr[i] = str;
            };
            inquiryService.genReport({
                rptId: rptId,
                rptParams: _.join(inpArr, ','),
                exptype: exptype
            }).then(data => {
                ToastUtil.success('common.request-gen-report-success');
            }).catch(error => {
                ToastUtil.errorApi(error, 'common.fail-to-gen-report')
            })
        } else {
            ToastUtil.error('common.no-account');
        }
    };

    genExcel = () => {
        this.genReport(reportTypes.XLSX);
    };

    genPdf = () => {
        this.genReport(reportTypes.PDF);
    };

    // run only once when component is mounted
    loadInitData = () => {
        const { accounts, language } = this.props;
        let newRow = (language === 'en') ? {
            id: "All",
            entypename: "Basis",
            accounttype: "ALL"
        } :
            {
                id: "Tất cả",
                entypename: "Cơ sở",
                accounttype: "ALL"
            }
        let found = [newRow, ...accounts]
        this._setState({ currentAccount: newRow, listAccounts: found });
    };

    setReloadData = (_onReloadData) => {
        let onReloadData = _onReloadData ? _onReloadData : !this.state.onReloadData
        this._setState({ onReloadData })
    }

    // Called only one time after component loaded
    componentDidMount() {
        this.mounted = true
        this.loadInitData();
        this.setReloadData();
        //focus vào ô nhập tài khoản KH khi vào màn hình
        if (this.isBroker()) {
            CommonUtils.onFirstRefFocusAccountSelector(this.selectAccountCustomerRef);
        }
    }

    // Called everytime props or state changed
    componentDidUpdate(prevProps, prevState) {
        const { currentAccount } = this.state;
        const { currentAccount: prevCurrentAccount } = prevState;
        const { language } = this.props;
        const { language: prevlanguage } = prevProps;

        if (language !== prevlanguage) {
            this.setReloadData()
        }

        if (this.isBroker() === true && JSON.stringify(this.props.curCustomer) !== JSON.stringify(prevProps.curCustomer)) {
            this.loadInitData()
        }

    }

    onFromDateChanged = (dates) => {
        this._setState({ fromDate: dates[0] });
    };

    onToDateChanged = (dates) => {
        this._setState({ toDate: dates[0] });
    };


    //Set tiểu khoản chuyển
    setCurrentAccount = (event) => {
        const { listAccounts } = this.state;
        let found = listAccounts.find(item => item.id === event.target.value)
        this._setState({ currentAccount: found })
    };

    defaultColumn = {
        headerClassName: "text-center",
    }

    getTotals = (data, key) => {
        let total = 0;
        data.forEach(item => {
            total += item[key];
        });
        return total;
    };

    formatFDS = (text) => {
        let check = String(text).search("FDS")
        if (!check) {
            return String(text).replace("FDS", '')
        }
        return text
    }

    handlerKeyDown = (event) => {
        const keyCode = event.which || event.keyCode;
        if (keyCode === KeyCodeUtils.ENTER) {
            event.preventDefault();
            if (!this.searchBtnRef.current || this.searchBtnRef.current.disabled) return;
            this.searchBtnRef.current.click();
        }
    };

    processOrderData = (data) => {
        let dataArr = data.d
        //console.log("processOrderData_1", dataArr)

        let newRecords = dataArr;
        //console.log("processOrderData_2", newRecords)
        if (newRecords.length > 0) {
            //console.log("processOrderData_3", newRecords)

            _.map(newRecords, (record) => {
                // record.proportion = this.getValidSumValue((record.basicPriceAmt * 100) / _sumCostMarket)// Tỷ trọng
                // record.proportion = CommonUtils.convertRound(record.proportion)
                record.sumPnlrate = record.netvalue + "|" + record.pnl + "|" + 100 // Với màn lãi lỗ đã thực hiện chỉ có case giá trị vốn = 0 thì %lãi lỗ = 100%
            })

            //console.log("processOrderData ====> return", newRecords)
            CM_RECORDS = newRecords;
            this._setState({ records: newRecords }); // phải cập nhật để render lại cho bảng devextreme nhận CM_RECORDS ==> Bất tiện
            return { ...data, d: newRecords }
        } else {
            //console.log("processOrderData_else", newRecords)
            return { ...data, d: [] }
        }
    }

    renderSumCustomExt = (column, dataGrid) => {
        const { customSumTable } = this.state
        let resultValue = ""
        let _sumPnlamt = 0
        let _sumCostPriceAmt = 0
        let cachedPagingData = (dataGrid && dataGrid._controllers && dataGrid._controllers.columns
            && dataGrid._controllers.columns._dataSource && dataGrid._controllers.columns._dataSource._cachedPagingData
        ) || []

        //console.log("renderSumCustomExt_2", cachedPagingData)

        _.map(cachedPagingData, (record) => {
            // //console.log("renderSumCustomExt_23", record.costPriceAmt, record.pnlamt, record.symbol)
            _sumPnlamt = _sumPnlamt + Number(record.pnl) // Giá trị lãi lỗ
            _sumCostPriceAmt = _sumCostPriceAmt + Number(record.netvalue) // Giá trị lãi lỗ
        })

        //console.log("renderSumCustomExt_sum", _sumPnlamt, _sumCostPriceAmt)
        // //console.log("renderSumCustomExt_start", customSumTable, column)
        if (column) {
            if (column == "pnlrate") {
                if (Number(_sumCostPriceAmt == 0)) {//Nếu giá vốn = 0 thì mặc định lãi/lỗ 100% (custom VIX)
                    resultValue = 100
                } else {
                    resultValue = (Number(_sumPnlamt) * 100) / Number(_sumCostPriceAmt) // Giá trị lãi lỗ / Giá trị vốn
                    resultValue = Util.formatAccountingWithZero(resultValue, 2) || 0
                }
                resultValue = `${resultValue} %`
            }
        }
        return resultValue
    }

    render() {
        const { language, accountInfo } = this.props;
        const { currentAccount, records, listAccounts, onReloadData } = this.state;
        const isFDS = currentAccount && currentAccount.accounttype === "FDS" ? true : false
        const isBroker = this.isBroker();
        const { curCustomer } = { ...accountInfo }
        let fullName = isBroker ? (curCustomer.fullName || '') : this.props.customerFullName;
        fullName = CommonUtils.getDisplayName(fullName);
        return (
            <RetryableContent className="consolidated-report report-content" status={this.state.loadStatus} disableRetry={true}>
                <div className="consolidated-report-content">
                    <div className="action-container">
                        <div className={'d-flex container-select ' + (this.props.isDeskTop ? 'flex-wrap' : '')}>
                            {
                                isBroker ?
                                    <div className="custom-form-group-n txt---400-14-20 padding-top-0">
                                        <SelectorAccountCustomer
                                            ref={this.selectAccountCustomerRef}
                                            curCustomer={curCustomer}
                                            selectorAcountScreen={SELECTOR_ACCOUNT_SCREEN.SCREEN_MODAL}
                                            disabled={false}
                                            className="custom-form-control txt---400-14-20"
                                        />
                                    </div>
                                    :
                                    <div className="custom-form-group txt---400-14-20">
                                        <input autoFocus={true} className='custom-form-control custom-form-control-custodycd' value={this.props.userInfo && this.props.userInfo.custodycd} readOnly />
                                    </div>
                            }
                            <div className="custom-form-group-n">
                                <select value={currentAccount ? currentAccount.id : ''} onChange={this.setCurrentAccount} className="custom-form-control txt---400-14-20">
                                    {(!listAccounts || listAccounts.length === 0 || !currentAccount) && (
                                        <FormattedMessage key="empty" id="header.choose-account">
                                            {(txt) => (
                                                <option key="empty" value="" disabled>{txt}</option>
                                            )}
                                        </FormattedMessage>
                                    )}
                                    {listAccounts && listAccounts.map((account) => {
                                        return (account.accounttype === "ALL" ? <option key={account.id} value={account.id}>{account.id}</option> :
                                            (<option key={account.id} value={account.id}>{account.cdcontent}</option>)
                                        )
                                    })}
                                </select>
                            </div>
                            {isBroker && <div className="custom-form-group-n fullname">
                                <div className='align-self-center txt---400-14-20' >
                                    {fullName}
                                </div>
                            </div>}
                            <div className="custom-form-group-n">
                                <div className='align-self-center label txt---400-14-20'><FormattedMessage id="common.from-date" /></div>
                                <DatePicker
                                    className="custom-form-control text-left txt---400-14-20"
                                    value={this.state.fromDate}
                                    onChange={this.onFromDateChanged}
                                    minDate={this.minDate}
                                />

                            </div>

                            <div className="custom-form-group-n">
                                <div className='align-self-center label txt---400-14-20'><FormattedMessage id="common.to-date" /></div>
                                <DatePicker
                                    className="custom-form-control text-left txt---400-14-20"
                                    value={this.state.toDate}
                                    onChange={this.onToDateChanged}
                                    minDate={this.minDate}
                                />

                            </div>

                            <div>
                                <button ref={this.searchBtnRef} className="txt---400-14-20 btn-search" onClick={this.search} onKeyDown={this.handlerKeyDown}>
                                    <FormattedMessage id="common.search" />
                                </button>
                            </div>

                        </div>
                        <div className="export-container text-right">
                            <div className="dropdown">
                                <TextToolTip
                                    tooltipText={<FormattedMessage id="common.export-tooltip" />}
                                    targetID='toolTipExportBtn'
                                ></TextToolTip>
                                <button className="btn-icon-fm-2" id={'toolTipExportBtn'}>
                                    {this.props.defaultTheme === 'dark' ? < DownloadIconLight /> : < DownloadIconDark />}
                                </button>
                                <div className="dropdown-menu dropdown-menu-right txt---400-14-20" aria-labelledby="dropdownMenuButton">
                                    <FormattedMessage id='common.export-to-pdf'>
                                        {(txt) => (
                                            <a className="dropdown-item" onClick={this.genPdf}>{txt}</a>
                                        )}
                                    </FormattedMessage>
                                    <FormattedMessage id='common.export-to-excel'>
                                        {(txt) => (
                                            <a className="dropdown-item" onClick={this.genExcel}>{txt}</a>
                                        )}
                                    </FormattedMessage>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='h-block-table p-table-10'>
                        <TableExtremeCustom2
                            keyStoreUpdate="producttypename" // key của row 
                            columnsDefault={columnsDefault} // ds cột
                            totalDefault={totalDefault} // ds sum (nếu có)
                            renderSwitch={this.renderSwitch} // func render dữ liệu
                            returnCaption={this.returnCaption} // func render column name
                            isUseSelection={false} // true/false: hiện/ẩn chọn row
                            isLoadPanel={true} // true/false: hiện/ẩn iconLoadPanel
                            addClass="order-history-paging" // class cha
                            isPager={true} // hiển thị giao diện phân trang
                            // apiPaging={this.apiPaging} // sử dụng Api phân trang: không trả ra totalCount
                            apiLoadAllByPagingRes={this.apiPaging}
                            onReloadData={onReloadData} // thay đổi giá trị này để render tableEx
                            defaultPageSizes={20}  //Truyền 
                            showFilter={true}
                            renderSumCustomExt={this.renderSumCustomExt}
                            listData={CM_RECORDS}
                        />
                    </div>
                </div>
            </RetryableContent >

        );
    }

}

const mapStateToProps = state => {
    let _accountInfo = state.layout.listIsOpenModal["C&B"]["ScreenModal"].accountInfo
    let { accounts, currentAccountId, curCustomer } = { ..._accountInfo }
    let defaultTheme = state.user.userInfo && state.user.userInfo.defaultTheme

    return {
        isDeskTop: state.app.isDeskTop,
        userInfo: state.user.userInfo,
        currentCustomer: state.customer.currentCustomer,
        role: state.user.userInfo.role,
        language: state.app.language,
        accounts: accounts,
        currentAccountId: currentAccountId,
        currentDate: state.app.currentDate,
        curCustomer: curCustomer,
        accountInfo: state.layout.listIsOpenModal["C&B"]["ScreenModal"].accountInfo,
        defaultTheme: defaultTheme,
        customerFullName: state.user.customerFullName,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        setExcelExportData: (filename, data) => dispatch(actions.setScreenExportData({ filename, data }))
    }
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ConsolidatedProfitLossReport));

